import { makeStyles } from "@mui/styles";

const dynamicStyle = makeStyles((them) => ({
  buttonGrid: {
    marginTop: "5px",
  },
}));

export default dynamicStyle;
